<template>
  <div class="arbitrate-upload-component">
    <!-- 缩小模式 -->
    <el-popover
      v-if="filePendingList.length > 0 && miniMode"
      placement="bottom"
      trigger="hover"
    >
      {{ filePendingList.length }} 个文件
      <span style="font-weight: 600">{{ totalProgress }}</span>
      <i
        slot="reference"
        class="el-icon-upload uploading cursorPointer"
        @click="miniMode = false"
      />
    </el-popover>
    <!-- End 缩小模式 -->

    <!--- 提交凭证弹框 --->
    <el-dialog
      top="3vh"
      width="700px"
      center
      :title="title"
      v-if="arbitrateUploadObj.visible"
      :visible="arbitrateUploadObj.visible"
      :close-on-click-modal="false"
      @close="dialogClose()"
    >
      <el-form label-width="90px">
        <el-form-item label="平台订单号">
          {{ arbitrateUploadObj.platformOrder }}
        </el-form-item>
        <el-form-item
          v-if="[0, 8].indexOf(arbitrateUploadObj.patchStatus) !== -1"
          label="付款人姓名"
        >
          <el-input
            style="width: 200px"
            size="small"
            clearable
            v-model="editData.tempPayerName"
          />
        </el-form-item>
        <el-form-item label="文字说明">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            v-model="editData.remark"
            maxlength="600"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="凭证说明" class="file-preview-item">
          <el-upload
            v-if="fileList.length === 0"
            :on-change="fileListChange"
            :auto-upload="false"
            name=""
            ref="fileUpload"
            :multiple="false"
            action=""
            :show-file-list="false"
            :file-list="fileList"
            :data="dataObj"
            :before-remove="beforeRemove"
            :headers="{ authorization }"
            accept=".jpg,.jpeg,.png,.mp4,.mov"
            drag
            style="text-align: center"
            :class="
              fileList && fileList.length > 0
                ? 'el-upload-dragger-has-file'
                : ''
            "
          >
            <div
              :style="`background-image: url(${uploadBg});`"
              class="upload-icon"
            >
              <div class="el-upload__text">将文件拖曳到此 或 点击上传</div>
            </div>
          </el-upload>

          <!-- 美食论坛 -->
          <template
            v-if="projectMode === 'rx' && arbitrateUploadObj.patchStatus"
          >
            <el-alert
              v-if="arbitrateUploadObj.patchStatus === -2"
              show-icon
              :closable="false"
              center="center"
              title="能够转账必须完成转账，无故直接失败系统可能会做出处罚"
              type="error"
              style="line-height: 20px; margin-bottom: 20px"
            >
            </el-alert>
            <el-alert
              v-if="arbitrateUploadObj.patchStatus === -3"
              show-icon
              :closable="false"
              center="center"
              title="此订单将直接结案并标记为失败（确认未出款），确认未出款？"
              type="error"
              style="line-height: 20px; margin-bottom: 20px"
            >
            </el-alert>
          </template>
          <!-- End 美食论坛 -->

          <!-- 文件列表 -->
          <template v-if="fileList && fileList.length > 0">
            <el-row>
              <el-col
                class="file-preview"
                v-for="(item, index) in fileList"
                :key="item.uid"
                :span="8"
              >
                <el-popconfirm
                  @confirm="removeFile(index)"
                  :title="`确定要删除「${item.name}」吗？`"
                >
                  <i slot="reference" class="el-icon-delete file-remove" />
                </el-popconfirm>

                <!-- 凭证类型图示 -->
                <!-- <div
                  style="position: absolute; left: 3px; top: 5px; z-index: 10"
                >
                  <el-tag
                    v-for="(typeItem, typeIndex) in item.type"
                    :key="'type' + item.uid + typeItem + typeIndex"
                    effect="plain"
                    size="mini"
                    closable
                    @close="removeTypeTag(item, typeIndex)"
                  >
                    <MediaType :type-item="typeItem" iconSize="16" />
                  </el-tag>
                </div> -->
                <!-- End 凭证类型图示 -->

                <video
                  style="width: 100%; height: 150px"
                  v-if="item.raw.type.match(/^video\//i)"
                  muted
                  autoplay
                  loop
                  :src="item.url"
                ></video>
                <div
                  v-if="
                    item.raw.type.match(/^video\//i) &&
                      item.raw.type !== 'video/mp4' &&
                      item.raw.type !== 'video/webm'
                  "
                  class="video-preview-fail"
                >
                  <i class="el-icon-video-camera" /><br />
                  视频可能会无法预览<br />但可正常上传
                </div>

                <img
                  v-if="item.raw.type.match(/^image\//i)"
                  style="width: 100%; height: 150px; object-fit: contain"
                  :src="item.url"
                />
                <div class="file-name read-more">
                  {{ item.name }}
                </div>

                <!-- <el-select
                  :disabled="item.type.length >= mediaTypeOptions.length"
                  v-model="item.chooseType"
                  placeholder="凭证类型"
                  size="mini"
                  @change="onChooseType(item)"
                >
                  <el-option
                    v-for="(checkBoxItem, checkBoxIndex) in mediaTypeOptions"
                    :key="checkBoxItem.label + checkBoxIndex"
                    :label="checkBoxItem.label"
                    :value="checkBoxItem.value"
                    :disabled="checkBoxItem.disabled"
                  >
                  </el-option>
                </el-select> -->
              </el-col>
            </el-row>
          </template>
          <!-- End 文件列表 -->

          <!-- 凭证类型 -->
          <!-- <MediaType v-if="fileList.length > 0" /> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()" size="small">取消</el-button>
        <el-button
          :loading="submitLoading"
          @click="submitVerify()"
          size="small"
          type="success"
          >提交
        </el-button>
      </span>
    </el-dialog>
    <!--- End 提交凭证弹框 --->

    <!--- 上传对列展示区块 --->
    <el-card v-if="filePendingList.length > 0 && !miniMode">
      <el-tooltip content="缩小" placement="top" effect="light">
        <i
          @click="miniMode = true"
          class="el-icon-minus cursorPointer mini-btn"
        />
      </el-tooltip>

      <el-tabs>
        <el-tab-pane :label="`凭证上传 (${filePendingList.length})`">
          <template v-if="filePendingList.length > 0">
            <div class="pending-container">
              <div
                v-for="(item, index) in filePendingList"
                :key="`${item.file}${item.uid}${new Date()}`"
                class="content"
              >
                <el-tag effect="dark" size="mini" :type="item.status">{{
                  item.platformOrder
                }}</el-tag
                ><br />
                <el-tag
                  size="mini"
                  style="margin: 5px 0"
                  effect="dark"
                  :type="item.status"
                  >{{ HandleReadMore(item.file, 20) }}</el-tag
                >
                <br />
                <el-progress
                  :percentage="item.progress"
                  :status="item.status === 'danger' ? 'exception' : null"
                ></el-progress>
                <el-divider v-if="filePendingList.length !== index + 1" />
              </div>
            </div>
          </template>
          <el-alert
            v-else
            title="文件全数上传成功"
            type="success"
            center
            :closable="false"
          >
          </el-alert>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--- End 上传对列展示区块 --->
  </div>
</template>

<script>
import uploadBg from "@/assets/images/upload-bg.png";
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import axios from "axios";
// import MediaType from "@/views/components/MediaType";

import {
  arbitrateSupplementDocument,
  arbitrateWithdrawSupplementDocument,
  getUploadMediaCiphertext
} from "@/api/order";

export default {
  mixins: [mainCommon],
  // components: {
  //   MediaType,
  // },
  computed: {
    title() {
      if (this.arbitrateUploadObj) {
        if (this.arbitrateUploadObj.type === "pay") {
          // 支付
          switch (this.arbitrateUploadObj.patchStatus.toString()) {
            case "0":
              return "申请仲裁";
            case "4":
              return "请商户提交凭证";
            case "5":
              return "驳回卡主";
            case "6":
              return "请卡主与商户提交凭证";
            case "7":
              return "商户提交凭证";
            case "8":
              return "商户重新发起申请";
            case "25":
              return "进入仲裁";
            default:
              return "-";
          }
        } else {
          // 提现
          switch (this.arbitrateUploadObj.patchStatus.toString()) {
            case "0":
              return "申请仲裁";
            case "4":
              return "请商户提交凭证";
            case "5":
              return "驳回卡主";
            case "6":
              return "请商户与卡主提交凭证";
            case "7":
              return "商户提交凭证";
            case "8":
              return "重新发起申请仲裁";

            /* --- 美食论坛 --- */
            case "1":
              return "认知出款";
            case "2":
              return "认知未出款";
            case "3":
              return "认知无法确认";
            case "-7":
              return "审核员转单";
            case "-6":
              return "进入审核";
            case "-4":
              return "关闭订单";
            case "-3":
              return "确认未出款";
            case "-2":
              return "无法完成转账";
            case "-1":
              return "确认出款，提交凭证"; // for 提现回单
            case "25":
              return "进入仲裁";
            // case "11":
            //   return "需卡主再次提交凭证";
            case "51":
              return "需卡主再次提交打款视频";
            case "52":
              return "需卡主再次提交账单视频";
            case "53":
              return "需卡主再次提交打款与账单视频";
            case "54":
              return "需卡主再次提交其他凭证";
            /* --- End 美食论坛 --- */

            default:
              return "-";
          }
        }
      } else {
        return "-";
      }
    },
    // 仲裁 obj
    arbitrateUploadObj: {
      get() {
        return this.$store.state.app.arbitrateUploadObj;
      },
      set(val) {
        this.$store.commit("SET_ARBITRATE_UPLOAD_OBJ", val);
      }
    },
    // 全部上传进度百分比
    totalProgress() {
      return (
        `( ${this.formatNumberWithCommasAndDecimalSeparator(
          this.filePendingList.reduce((total, obj) => total + obj.progress, 0) /
            this.filePendingList.length || 0
        )} %)` || ""
      );
    }
  },
  watch: {
    filePendingList(row) {
      this.submitPendingList.forEach(resObj => {
        if (
          row.filter(
            item =>
              item.platformOrder === resObj.platformOrder &&
              resObj.status === "" &&
              item.status === ""
          ).length === 0
        ) {
          this.submitArbitrateSupplement(resObj);
        }
      });
    },
    // 上传弹框物件
    arbitrateUploadObj(val) {
      if (val.visible) {
        this.clearFields();

        // 上传要验证 auth 的密文 base64 obj
        this.authorization = btoa(
          JSON.stringify({
            username: this.userInfo.username,
            userType: this.userInfo.userType,
            date: this.HandleDateYMDFormat(new Date())
          })
        );

        // 获得密文
        if (this.arbitrateUploadObj.orderId) {
          const obj = { orderId: this.arbitrateUploadObj.orderId };
          // 美食论坛：支付 0, 提现 1
          if (this.projectMode === "rx") {
            obj.orderType = this.arbitrateUploadObj.type === "pay" ? "0" : "1";
          }
          getUploadMediaCiphertext(obj)
            .then(res => {
              this.dataObj.ciphertext = res.data;
            })
            .catch(() => {
              this.$notify.error(
                `「${this.arbitrateUploadObj.platformOrder}」请稍后再试`
              );
            });
        }

        document.addEventListener("paste", this.pasteUploadFile); // 监听黏贴事件
        window.addEventListener("beforeunload", this.beforeReload); // 监听重刷页面
      }
    }
  },
  data() {
    return {
      mediaTypeOptions: varCommon.mediaTypeOptions, // 凭证类型
      uploadBg, // 上传区块背景图示
      projectMode: "rx", // ra|rx for 双平台更新暂时这样处理，两边同步后改掉
      miniMode: false, // 缩小模式
      submitPendingWhiteList: [], // 提交列表白名单
      submitPendingList: [], // 提交对列
      filePendingList: [], // 上传对列
      submitLoading: false,
      fileList: [], // 文件列表
      authorization: null,
      uploadURL: `${process.env.BASE_API.replace(
        "api2/",
        ""
      )}media/file/uploadArbitrateMedia`, // 上传接口
      dataObj: { ciphertext: null }, // 上传密文
      editData: {}, // 栏位数据
      uploadSizeLimit: {
        image: 3,
        video: 20
      } // 单笔文件大小限制 (单位：MB)
    };
  },
  methods: {
    // 针对文件选择凭证类型
    // onChooseType(item) {
    //   const typeLabel = this.getMediaTypeLabel(item.chooseType);
    //   if (item.type.indexOf(item.chooseType) !== -1) {
    //     this.$notify.error(`該文件已經有「${typeLabel}」凭证类型，请重新选择`);
    //     item.chooseType = null;
    //     return;
    //   }
    //   item.type.push(item.chooseType);
    //   this.$message.success(`成功添加「${typeLabel}」凭证`);
    //   // this.mediaTypeOptions.forEach((res) => {
    //   //   if (res.value === item.chooseType) {
    //   //     res.disabled = true;
    //   //   }
    //   // });
    // },
    // 移除文件凭证类型
    // removeTypeTag(item, index) {
    //   // this.mediaTypeOptions.forEach((res) => {
    //   //   if (res.value === item.tag[index]) {
    //   //     delete res.disabled;
    //   //   }
    //   // });
    //   item.type.splice(index, 1);
    //   item.chooseType = null;
    // },
    // 黏贴簿事件
    pasteUploadFile(e) {
      // 如果提交凭证弹窗没有开启，不理会黏贴监听
      if (!this.arbitrateUploadObj.visible) return;

      // 取得黏贴簿数据
      const items = (e.clipboardData || window.clipboardData).items;

      // 忽略文字贴上
      if (items && items[0] && items[0].type === "text/plain") return;

      for (let i = 0; i < items.length; i++) {
        document.activeElement.blur(); // 强制移除所有聚焦

        const reader = new FileReader();
        const getAsFile = items[i].getAsFile();
        reader.readAsDataURL(getAsFile);
        reader.onload = () => {
          this.fileList.push({
            data: { ciphertext: this.dataObj.ciphertext },
            name: getAsFile.name,
            url: this.getBlobURL(getAsFile),
            raw: this.base64ToFile(reader.result, getAsFile.name),
            fileType: getAsFile.type.match(/^video\//i) // 如果是视频
              ? "video"
              : getAsFile.type.match(/^image\//i) // 如果是圖片
              ? "photo"
              : null
            // type: [],
            // chooseType: null,
          });
        };
      }
    },
    // 上传文件时调用
    fileUpload(row, uid, platformOrder, id) {
      const formData = new FormData();
      formData.append("file", row.raw); // 将文件添加至 FormData
      formData.append("ciphertext", row.data.ciphertext);

      axios
        .post(this.uploadURL, formData, {
          headers: {
            authorization: this.authorization
          },
          onUploadProgress: progressEvent => {
            // 上传进度百分比
            this.filePendingList.map(res => {
              if (uid === res.uid) {
                res.progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              }
              return res;
            });
          }
        })
        .then(response => {
          // 上传对列
          const filePending = this.filePendingList.find(
            item => item.uid === uid
          );
          // 提交对列
          const submitPending = this.submitPendingList.find(
            item => item.platformOrder === platformOrder
          );

          // 上传失败
          if (response.data.code !== 200) {
            filePending.status = "danger";
            submitPending.status = "failed";
            this.clearPending({ platformOrder, id });
            this.$message.error(response.data.message);
            return;
          }

          // 上传成功，将文件写入提交对列
          this.submitPendingList.map(res => {
            if (res.platformOrder === platformOrder && res.status === "") {
              res.submitObj.mediaList.push({
                type: "999", // row.type.join()
                url: response.data.data,
                fileType: row.fileType
              });
            }
            return res;
          });

          this.filePendingList.splice(this.filePendingList.indexOf(row.uid), 1); // 只有上传成功，才将文件排程从对列中移除
        })
        .catch(err => {
          this.$notify.error(
            `「${row.raw.name}」上传失败 (${err || "上传时发生错误"})`
          );
        });
    },
    // 提交凭证
    submitArbitrateSupplement(resObj) {
      if (resObj.status !== "") return; // 若提交对列不是正常状态，不实施提交

      // 发起仲裁给 appOrder
      const patchStatus = [0, 8];
      if (this.projectMode === "rx") {
        patchStatus.push(-1, -2, -4, -6);
      }

      if (patchStatus.indexOf(resObj.submitObj.patchStatus) !== -1) {
        resObj.submitObj.appOrder = resObj.id;
      } else {
        // 接下来的过程都用 仲裁 ID 处理
        resObj.submitObj.arbitrationApplyId = resObj.id;
      }

      // 检查若没有在提交白名单中
      if (this.submitPendingWhiteList.indexOf(resObj.id) === -1) {
        this.submitLoading = true;
        this.submitPendingWhiteList.push(resObj.id); // 加入提交白名单，避免重复提交
        if (this.arbitrateUploadObj && this.arbitrateUploadObj.type === "pay") {
          // 支付
          arbitrateSupplementDocument(this.ObjectClean(resObj.submitObj))
            .then(() => {
              this.$notify.success(`「${resObj.platformOrder}」提交成功`);
              this.$store.dispatch("GetUnallocatedAll");
              this.arbitrateUploadObj.uploading = true;
              this.arbitrateUploadObj.pop = false;
            })
            .finally(() => {
              this.clearPending(resObj);
              this.submitLoading = false;
            });
        } else {
          // 如果是卡主关闭订单，不用给 isPayer
          /* --- 美食论坛 --- */
          if (
            this.projectMode === "rx" &&
            resObj.submitObj.patchStatus !== -4 &&
            resObj.submitObj.patchStatus !== -6
          ) {
            resObj.submitObj.isPayer = true;
          }
          /* --- End 美食论坛 --- */

          // 提现
          arbitrateWithdrawSupplementDocument(
            this.ObjectClean(resObj.submitObj)
          )
            .then(() => {
              this.$notify.success(`「${resObj.platformOrder}」提交成功`);
              this.$store.dispatch("GetUnallocatedAll");
              this.arbitrateUploadObj.uploading = true;
              this.arbitrateUploadObj.pop = false;
            })
            .finally(() => {
              this.clearPending(resObj);
              this.submitLoading = false;
            });
        }
      }
    },
    // 提交前验证
    submitVerify() {
      const platformOrder = this.arbitrateUploadObj.platformOrder;

      // 正在等待上传对列不给同时二次提交，除非等提交对列结束
      if (
        this.submitPendingList.find(
          row => row.platformOrder === platformOrder && row.status === ""
        )
      ) {
        return this.$message.error(`「${platformOrder}」重复上传，请稍后重试`);
      }

      // 某条件下，付款人姓名必填
      if (
        [0, 8].indexOf(this.arbitrateUploadObj.patchStatus) !== -1 &&
        !this.editData.tempPayerName
      ) {
        return this.$notify.error("请填写付款人姓名");
      }

      if (this.fileList.length === 0 && !this.editData.remark) {
        return this.$notify.error("文字说明、图片、视频请至少填写一项");
      }

      // 指定身分，图片或视频至少选一项上传
      if (
        this.fileList.length === 0 &&
        this.arbitrateUploadObj.sellerRelatedStatus === 1 &&
        ["seller", "switchboard", "customer"].indexOf(
          this.userInfo.userType
        ) !== -1 &&
        this.projectMode === "ra" // 融安
      ) {
        return this.$notify.error("图片或视频至少选一项上传");
      }

      this.$confirm("确定提交凭证吗？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning"
      })
        .then(() => {
          if (this.fileList.length > 0) {
            // 如果有上传文件，创建提交对列
            this.submitPendingList.push({
              id: this.arbitrateUploadObj.id,
              platformOrder,
              status: "",
              submitObj: {
                patchStatus: this.arbitrateUploadObj.patchStatus, // 凭证状态
                yyCheckOrderStatus: this.arbitrateUploadObj.yyCheckOrderStatus, // YY查单状态
                remark: this.editData.remark, // 备注
                tempPayerName: this.editData.tempPayerName, // 付款人姓名
                mediaList: [] // 文件列表
              }
            });

            this.fileList.forEach(row => {
              const uid = Math.random()
                .toString(16)
                .slice(2); // 统一建立独立的 unique id 给进度条使用

              // 创建上传对列，展示排程使用
              this.filePendingList.push({
                uid,
                platformOrder,
                file: row.raw.name,
                progress: 0,
                status: ""
              });

              // 文件上传排程，依序打接口上传文件
              this.fileUpload(
                row,
                uid,
                platformOrder,
                this.arbitrateUploadObj.id
              );
            });
          } else {
            // 仅纯文字说明，直接提交
            this.submitArbitrateSupplement({
              id: this.arbitrateUploadObj.id,
              platformOrder,
              status: "",
              submitObj: {
                patchStatus: this.arbitrateUploadObj.patchStatus,
                yyCheckOrderStatus: this.arbitrateUploadObj.yyCheckOrderStatus, // YY查单状态
                remark: this.editData.remark,
                tempPayerName: this.editData.tempPayerName
              }
            });
          }

          this.dialogCancel();
        })
        .catch(() => {});
    },

    /* --- 关闭弹窗 --- */
    dialogClose() {
      this.arbitrateUploadObj.pop = false;
      this.$refs.fileUpload.clearFiles();
      this.dialogCancel();
    },
    dialogCancel() {
      this.arbitrateUploadObj.visible = false;

      this.clearFields();
      this.fileList = [];

      document.removeEventListener("paste", this.pasteUploadFile); // 关闭黏贴监听
    },
    /* --- End 关闭弹窗 --- */

    // 移除文件时调用
    removeFile(index) {
      this.fileList.splice(index, 1);
    },
    // 如果仍有提交对列，在页面重刷时的提醒
    beforeReload(e) {
      if (this.submitPendingList.length > 0) {
        e.returnValue =
          "你有凭证正在提交，你确定要重刷页面吗？提交请求将会被全数取消。";
        return e.returnValue;
      } else {
        window.removeEventListener("beforeunload", this.beforeReload);
      }
    },
    clearPending(resObj) {
      // 清除提交对列
      this.submitPendingList.splice(
        this.submitPendingList.indexOf(resObj.platformOrder),
        1
      );
      // 清除白名单
      this.submitPendingWhiteList.splice(
        this.submitPendingWhiteList.indexOf(resObj.id),
        1
      );
    },
    // 清除栏位值
    clearFields() {
      this.editData = {
        remark: null, // 备注
        tempPayerName: null // 付款人姓名
      };
    },
    // 移除文件时调用
    beforeRemove(file) {
      return this.$confirm(`确定移除「${file.name}」文件？`);
    },
    // 当 fileList 变动时的调用
    fileListChange(file) {
      const isImage = /\.(jpg|jpeg|png)$/i.test(file.name);
      const isVideo = /\.(mp4|mov)$/i.test(file.name);

      if (!isImage && !isVideo) {
        this.$message.warning("凭证只能是 jpg, jpeg, png, mp4, mov 格式!");
        return;
      }

      const fileSizeInMB = file.size / 1024 / 1024;
      const sizeLimit = isImage
        ? this.uploadSizeLimit.image
        : this.uploadSizeLimit.video;

      if (fileSizeInMB > sizeLimit) {
        this.$message.warning(
          `${isImage ? "图片" : "视频"}大小不可超过 ${sizeLimit} MB`
        );
        return;
      }

      this.fileList.push({
        url: this.getBlobURL(file.raw), // 暂时预览图
        data: { ciphertext: this.dataObj.ciphertext },
        fileType: file.raw.type.match(/^video\//i) // 如果是视频
          ? "video"
          : file.raw.type.match(/^image\//i) // 如果是图片
          ? "photo"
          : null,
        name: file.name,
        raw: file.raw,
        size: file.size,
        uid: file.uid
        // type: [],
        // chooseType: null,
      });
    },
    // 将黏贴簿事件产生的 base64 url 转为实际文件
    base64ToFile(url, name) {
      var arr = url.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },
    // 取得凭证类型名称
    getMediaTypeLabel(type) {
      const data = this.mediaTypeOptions.find(
        item => Number(type) === item.value
      );
      return data ? data.label : "-";
    }
  }
};
</script>

<style lang="scss" scoped>
.arbitrate-upload-component /deep/ {
  .el-tag--plain {
    border-radius: 3px;
    background-color: #fff;
    color: transparent;
    border-color: #fbfbfb;
    margin: 0 3px 3px 0;
    height: 27px;
    box-shadow: 1px 1px 2px 1px #ddd;
    .el-icon-close {
      transform: scale(1);
      margin: -16px 0 0 -6px;
      font-weight: 600;
    }
  }
  .read-more {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .upload-icon {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    font-weight: 600;
  }
  .pending-container {
    min-height: 1px;
    max-height: 45vh;
    overflow-y: auto;
    overflow-x: hidden;
    .content {
      position: relative;
      .delete-icon {
        position: absolute;
        right: 0;
        top: 0;
        color: #f56c6c;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .mini-btn {
    position: absolute;
    top: 12px;
    right: 15px;
    z-index: 2;
  }
  .el-tabs__item {
    padding: 0 10px;
  }
  .file-preview-item {
    .el-form-item__content {
      line-height: 15px;
    }
  }
  .file-preview {
    border: 1px #eee solid;
    border-radius: 5px;
    position: relative;
    padding: 5px;
    .video-preview-fail {
      position: absolute;
      text-align: center;
      left: 0;
      top: 60px;
      width: 100%;
      font-size: 12px;
      font-weight: 600;
    }
    .file-remove {
      cursor: pointer;
      position: absolute;
      right: 2px;
      bottom: 2px;
      font-size: 17px;
      padding: 5px;
      z-index: 100;
      background-color: #ffb8b8;
      color: #fff;
      &:hover {
        background-color: #ff0000;
      }
    }
    .file-name {
      height: 30px;
      color: #000;
      background-color: rgba($color: #fff, $alpha: 0.5);
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
  .uploading {
    font-size: 30px;
    position: absolute;
    top: 10px;
    right: 360px;
    z-index: 2000;
    animation: uploading 1.222s infinite;
  }
  .el-card {
    width: 230px;
    position: fixed;
    right: 20px;
    top: 70px;
    z-index: 10000;
    .el-card__body {
      padding: 0 15px 15px 15px;
    }
  }
  .el-upload-dragger {
    background-color: transparent;
    width: 240px;
    height: 200px;
    margin-left: -90px;
    .el-upload__text {
      height: 200px;
      line-height: 200px;
      font-size: 16px;
    }
  }
  /* 如果有拉档案，把 upload 区块缩小 */
  .el-upload-dragger-has-file .el-upload-dragger {
    width: 230px;
    height: 50px;
    .el-upload__text {
      height: 50px;
      line-height: 50px;
      font-size: 13px;
      color: #bfbfbf;
    }
  }
  .icon-position {
    font-size: 45px;
    padding-top: 20px;
  }
}
@keyframes uploading {
  0%,
  100% {
    color: #ff0000;
  }
  50% {
    color: #ef9713;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/dialog/ArbitrateUpload.vue